import styled from 'styled-components';

import { ThemeMode } from '@/helpers/enums';
import { detailsRichText } from '@/styles/richText';

export interface IScFaqItemProps {
  isSelected?: boolean;
  width?: string;
  arrow?: boolean;
  mode?: ThemeMode;
}

export const ScQuestionAnswerItem = styled.div<IScFaqItemProps>`
  width: 100%;
  min-height: 25px;
  background-color: ${({ theme, mode }) =>
    mode === ThemeMode.Dark ? theme.grayLightColor : theme.gray1Color};
  color: ${({ theme, mode }) =>
    mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;

  & > .question {
    color: ${({ theme, mode }) =>
      mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    cursor: pointer;
    padding: 16px;
    padding-bottom: 16px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    transition: 0.2s;
    column-gap: 16px;
    z-index: 2;

    @media (hover: hover) {
      &:hover {
        color: ${({ theme }) => theme.mainColor};

        & > .open-close-btn {
          &::before,
          &::after {
            background-color: ${({ theme, mode }) =>
              mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
          }
        }

        .arrow > i {
          color: ${({ theme }) => theme.blackColor};
        }
      }
    }

    & > .arrow {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 16px;
      height: 16px;
      transform: rotate(
        ${({ isSelected }) => (isSelected ? '-90deg' : '90deg')}
      );

      & > i {
        color: ${({ isSelected, theme }) =>
          isSelected ? theme.blackColor : theme.blackLightColor};
      }
    }

    & > .open-close-btn {
      width: 21px;
      height: 21px;
      flex-shrink: 0;
      position: relative;
      &::before,
      &::after {
        content: '';
        display: block;
        background-color: ${({ theme }) => theme.blackLightColor};
        position: absolute;
        transition: transform 500ms ease;
      }

      &::before {
        width: 100%;
        height: 1px;
        left: 0;
        top: 50%;
        transform: rotate(
          ${({ isSelected }) => (isSelected ? '180deg' : '0deg')}
        );
      }

      &::after {
        width: 1px;
        height: 100%;
        left: 50%;
        top: 0;
        transform: rotate(
          ${({ isSelected }) => (isSelected ? '90deg' : '0deg')}
        );
      }
    }
  }

  & > .answer-box {
    display: grid;
    grid-template-rows: ${({ isSelected }) => (isSelected ? '1fr' : '0fr')};
    transition: grid-template-rows
      ${({ isSelected }) => (isSelected ? '0.4s' : '0.2s')} ease;

    & > .answer {
      font-size: 16px;
      line-height: 24px;
      padding: 0 16px;
      overflow: hidden;
      z-index: 2;

      & > p {
        padding-bottom: 16px;
        white-space: pre-line;
      }

      ${detailsRichText}
    }
  }
`;
